import alt from "../alt";
import indexBy from "lodash/keyBy";
import extend from "lodash/extend";
import values from "lodash/values";
import SystemStatesUtil from "../utils/SystemStatesUtil";
import SystemStatesActions from "../actions/SystemStatesActions";
import UserStore from "../stores/UserStore";

class SystemStatesStore {
  constructor() {
    this.bindActions(SystemStatesActions);

    this.state = {
      location_data: {
        continents: [],
        countries: [],
        regions: []
      },
      isFetching: false
    };

    this.exportPublicMethods({
      getLocationData: this.getLocationData.bind(this)
    });
  }

  getLocationData() {
    return this.state.location_data;
  }

  onFetchLocationData() {
    this.setState({ isFetching: true });
    SystemStatesUtil.fetchLocationData(UserStore.getState().apiKey)
      .then(data => {
        this.setState({ isFetching: false, location_data: data });
      })
      .catch(SystemStatesActions.fetchFailed);
  }

  onFetchFailed(e) {
    this.setState({ isFetching: false });
    alert(`Fetching system state / location data failed: ${e.message}`);
    throw e;
  }
}

export default alt.createStore(SystemStatesStore, "SystemStatesStore");



// WEBPACK FOOTER //
// ./src/app/stores/SystemStatesStore.js